export default "__VITE_ASSET__BtUNeW2Q__"